module.exports = __webpack_public_path__ + "static/media/nascitaEmiliaArrigoni.24e9d2c3.jpg";